import { api2 , apiUpload } from './ApiService';

export default class FlashPackageService {
    

    static async search(key,page,perpage){
        let data ={
            key: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/flash/package/search`,data)
        return response.data
    }
 
    static async create(data){
        let response = await apiUpload.post(`/api/v1/flash/package/create`,data)
        return response.data
    }
    static async update(data){
        let response = await apiUpload.post(`/api/v1/flash/package/update`,data)
        return response.data
    }
    static async updateFlashDate(data){
        let response = await apiUpload.post(`/api/v1/flash/package/update/time`,data)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/flash/package/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/FlashPackageService.js